import { useAuth } from "../../../../shared/context/auth";
import { useGetPurchaseHistoryList, useSendPurchaseOrderSummary } from "./dataloader";
import React from "react";
import { ApiPurchaseOrderSummaryRequest } from "../../../../shared/types/ApiPurchaseOrderSummaryRequest";
import useLogAnalyticsScreenHook from "apps/myExperience/context/analyticsWrapper/hooks/useLogAnalyticsScreenHook";
import { AnalyticsActionNameEnum, AnalyticsEventNameEnum, AnalyticsScreenNameEnum } from "shared/enums/AnalyticsEnums";
import { useMyExpAnalytics } from "apps/myExperience/context/analyticsWrapper";
import AnalyticsDatastoreType from "shared/enums/AnalyticsDatastoreType";

export default function usePurchaseHistoryService() {
  const auth = useAuth();
  const { logEvent } = useMyExpAnalytics();
  useLogAnalyticsScreenHook({ properties: { screenType: AnalyticsScreenNameEnum.PURCHASE_HISTORY_LIST } });
  const { data: purchaseHistoryList = [] } = useGetPurchaseHistoryList(auth.userDetail?.id as string);
  const { mutateAsync: sendPurchaseHistorySummary } = useSendPurchaseOrderSummary();

  const sendAllInvoicesHandler = React.useCallback(async () => {
    const reqObj: ApiPurchaseOrderSummaryRequest = {
      registrationParticipantId: auth.userDetail?.id as string,
      purchaseOrders: purchaseHistoryList.map(item => item.purchaseOrderId)
    };
    try {
      logEvent(
        AnalyticsEventNameEnum.CLICK,
        {
          screenType: AnalyticsScreenNameEnum.PURCHASE_INVOICE,
          action: AnalyticsActionNameEnum.EMAIL
        },
        AnalyticsDatastoreType.MIXPANEL_INTERNAL
      );
      await sendPurchaseHistorySummary(reqObj);
    } catch (e) {}
  }, [sendPurchaseHistorySummary, auth.userDetail, purchaseHistoryList, logEvent]);

  return { purchaseHistoryList, sendAllInvoicesHandler };
}
